<script>
  // import AlertMessage from '@/components/alert-message.vue'
  import CardTile from '@/components/card-tile.vue'
  import DepartmentCard from '@/components/card-department.vue'
  import WeeklyHighlightsCard from '@/components/card-weekly-highlights.vue'
  // import FeatureCard from '@/components/card-feature.vue'
  import FeaturedRowHome from '@/components/featured-row-home'
  import HeroHome from '@/components/hero-home.vue'
  import NewMaterialCard from '@/components/new-material-sample-card.vue'
  import ProgramsCard from '@/components/card-programs.vue'
  export default {
    name: 'home-view',
    //AlertMessage,
    components: {
      CardTile,
      DepartmentCard,
      FeaturedRowHome,
      HeroHome,
      NewMaterialCard,
      ProgramsCard,
      WeeklyHighlightsCard
    },
    data: () => ({
      alertVisible: true,
      departmentCards: [
        {
          bottomShadow: 'light',
          cardColor: 'primary',
          color: 'secondary',
          primaryTextColor: 'primary',
          // image: 'adult_feature.jpg',
          image: 'https://media.eipl.org/site/images/pages/home/adult-department.jpg',
          buttonColor: 'primary',
          buttonTextColor: 'secondary',
          buttonTo: 'adult',
          titleText: 'ADULTS',
          bodyText: null,
          buttonText: 'ADULTS',
          icon: 'mdi-book-open-variant',
          imagePosition: 'top center'
        },
        {
          bottomShadow: 'dark',
          cardColor: 'green',
          color: 'secondary',
          primaryTextColor: 'green',
          // image: 'kids_feature.jpg',
          image: 'https://media.eipl.org/site/images/pages/home/kids-department.jpg',
          buttonColor: 'green',
          buttonTextColor: 'secondary',
          buttonTo: 'kids',
          titleText: 'KIDS',
          bodyText: null,
          buttonText: 'KIDS',
          icon: 'mdi-toy-brick',
          imagePosition: 'left center'
        },
        {
          bottomShadow: 'dark',
          cardColor: 'cyan',
          color: 'secondary',
          primaryTextColor: 'cyan',
          // image: 'teen_feature.jpg',
          image: 'https://media.eipl.org/site/images/pages/home/teen-department.jpg',
          buttonColor: 'cyan',
          buttonTextColor: 'secondary',
          buttonTo: 'teen',
          titleText: 'TEENS',
          bodyText: null,
          buttonText: 'TEENS',
          icon: 'mdi-gamepad',
          imagePosition: 'top center'
        }
      ],
      programModal: false,
      programModalItem: null,
      subCards: [
        {
          id: 123456,
          text: 'LIBRARY CARDS',
          icon: null,
          image: 'https://media.eipl.org/site/images/services/librarycard.jpg',
          link: { to: '/services/library-card' },
          primaryColor: 'blue',
          secondaryColor: 'secondary'
        },
        {
          id: 1234569,
          text: 'NEWSLETTER',
          icon: null,
          image: 'https://media.eipl.org/site/images/pages/home/library-newsletters.png.webp',
          link: { to: '/newsletter' },
          primaryColor: 'orange',
          secondaryColor: 'secondary'
        },
        {
          id: 123457,
          text: 'REMOTE PRINTING',
          icon: null,
          image: 'https://media.eipl.org/site/images/services/remote-print.jpg',
          // image: 'https://media.eipl.org/site/images/services/wireless-printing2.jpg',
          link: { to: '/services/remote-printing' },
          primaryColor: 'green',
          secondaryColor: 'secondary'
        },
        {
          link: { to: '/services/select-books' },
          // link: { href: 'https://eiplblog.wordpress.com', isExternal: true },
          icon: null,
          id: 1234578,
          image: 'https://media.eipl.org/site/images/services/select-books.jpg',
          primaryColor: 'red',
          secondaryColor: 'secondary',
          text: 'SELECT BOOKS'
        }
      ]
    }),
    methods: {
      showProgramModal(listItem) {
        console.log(listItem)
        this.programModalItem = listItem
        this.programModal = true
      }
    },
    computed: {
      libraryImage() {
        if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
          return 'https://media.eipl.org/site/images/sm/library_front.jpg'
        } else {
          return 'https://media.eipl.org/site/images/lg/library_front.jpg'
        }
      },
      cardTitleClass() {
        // const itemClass = {
        //   xs: ['display-1'],
        //   sm: ['display-1'],
        //   md: ['display-1'],
        //   lg: ['display-1'],
        //   xl: ['display-1']
        // }
        // return itemClass[this.$vuetify.breakpoint]
        // console.log(itemClass)
        return ['secondary--text', 'cardTitle']
        // return 'cardTitle'
      }
    }
  }
</script>
<template>
  <v-container class="main-container pa-0 pb-16">
    <v-row style="margin-top: 65px">
      <!-- <alert-message :showAlert="alertVisible"></alert-message> -->
      <!-- <v-row> -->
      <v-col cols="12" class="pa-0">
        <hero-home></hero-home>
      </v-col>
    </v-row>

    <v-row justify="center" align="center" dense class="mt-2">
      <template v-for="(deptCard, key) in departmentCards">
        <v-col cols="12" sm="4" lg="4" :key="'deptCard' + key">
          <departmentCard v-bind="deptCard"></departmentCard>
        </v-col>
      </template>
    </v-row>
    <v-container fluid>
      <v-row justify="center" align="center" align-lg="start" justify-lg="space-between" dense class="mt-2">
        <!-- xl="6" -->
        <v-col cols="12" xl="6">
          <!-- backgroundImage="https://media.eipl.org/site/images/pages/home/many-tear-off-day-calendar-with-focus.jpg"  -->
          <programsCard cardColor="primary" textColor="secondary"></programsCard>
          <weekly-highlights-card class="mt-4"></weekly-highlights-card>
        </v-col>
        <!-- xl="6" -->

        <v-col cols="12" xl="6" align-self="stretch" class="d-flex align-center justify-center">
          <v-row dense align="start" align-sm="center" justify="center" justify-md="space-around" style="height: 100%">
            <template v-for="subCard in subCards">
              <v-col cols="11" md="5" xl="9" :key="subCard.id" class="d-flex align-center justify-center my-16 my-xl-0 pa-0">
                <cardTile v-bind="subCard"></cardTile>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
      <featured-row-home />
      <v-row class="mt-12">
        <v-col col="12">
          <newMaterialCard></newMaterialCard>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<style scoped>
  /* html {
  background: #fafafa;
  font-family: bookman-jf-pro, serif;
  font-weight: 400;
  font-style: normal;
} */
  >>> .v-list--two-line.v-list--dense .v-list__item {
    height: 58px;
  }

  .theme--light.v-list-item--active:hover::before,
  .theme--light.v-list-item--active::before {
    opacity: 1;
    color: green;
    background-color: wheat;
  }

  .alert-message {
    position: sticky;
  }

  .carousel-3d-container figure {
    margin: 0;
  }

  .carousel-3d-container figcaption {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-weight: bold;
    bottom: 0;
    position: absolute;
    bottom: 0;
    padding: 0.5em;
    font-size: 1.2em;
    min-width: 100%;
    box-sizing: border-box;
  }
</style>
